import {Component, HostListener, inject, OnInit, ChangeDetectionStrategy, ViewEncapsulation} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {LanguageService} from '@app/core/services/language.service';
import {TranslatePipe} from '@ngx-translate/core';
import {AuthService} from '@core/services/auth.service';
import {AppRoutes} from '@core/constant/app-routes.constant';

@Component({
  selector: 'app-navbar',
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslatePipe
  ],
  templateUrl: './navbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {
  language!: string;
  languageService = inject(LanguageService);
  authService = inject(AuthService);
  public readonly appRoutes = AppRoutes;
  isScrolled = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 50;
  }

  ngOnInit(): void {
    this.language = this.languageService.getLanguage()
  }

  toggleLanguage(lang: string) {
    this.languageService.changeLanguage(lang);
    this.language = lang;
  }

  logout() {
    this.authService.logout();
  }

}
